
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import LastLogs from "@/components/logs/LastLogs.vue";
import KeyStatus from "@/components/keys/KeyStatus.vue";
import {Getter} from "vuex-class";

@Component({
    components: {
        KeyStatus,
        LastLogs,
    },
})
export default class KeyDetail extends Vue {
  @Prop({default: []})
  public selectedKeys: object[];

  private currentKey: any = null;
  private loadingLogs: boolean = false;
  private logs: any = null;
  @Getter private canDoInEnvCompany: (right: string) => boolean;

  get lastKey() {
    const lastIndex = this.selectedKeys.length - 1;
    return this.selectedKeys[lastIndex];
  }

  get lang(): string {
    return this.$root.$i18n.locale;
  }

  @Watch("selectedKeys", { deep: true })
  public handlerSelectedKeys(newVal, oldVal) {
    if (newVal.length === 1) {
      this.currentKey = newVal[0];
    } else if (newVal.length < oldVal.length) {
      this.currentKey = this.lastKey;
    } else {
      let change: boolean = false;
      newVal.map((key, i) => {
        if (!oldVal.find((x) => x.id === key.id)) {
          change = true;
          this.currentKey = key;
        }
      });
    }
  }

  private getStatusPicto(key: any) {
      switch (key.status) {
          case "CREATED": return "icon-picto_cle-partagees";
          case "WITH_SOMEBODY": return "icon-picto_cle-partagees";
          case "IN_RELAY": return "icon-picto_relais-agence";
          case "LATE": return "icon-picto_attention";
          case "IN_TRANSIT": return "icon-picto_courrier";
          default: return "icon-picto_cle-partagees";
      }
  }
}
